import React from 'react';

const PasswordContext = React.createContext({});

export const Provider = PasswordContext.Provider;
export const Consumer = PasswordContext.Consumer;